import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
export function ForbiddenPage() {
  return <div className="min-h-screen bg-background text-textMain flex items-center justify-center p-6" data-id="element-6386">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-md w-full bg-surface border border-border rounded-2xl p-8 text-center" data-id="element-6387">
        <div className="w-16 h-16 rounded-full bg-red-500/10 text-red-500 flex items-center justify-center mx-auto mb-6" data-id="element-6388">
          <ShieldAlert className="w-8 h-8" data-id="element-6389" />
        </div>
        <h1 className="text-2xl font-bold mb-2" data-id="element-6390">Access Denied</h1>
        <p className="text-textMuted mb-8" data-id="element-6391">
          You don't have permission to view this page or perform this action. If
          you believe this is a mistake, please contact your workspace
          administrator.
        </p>
        <div className="space-y-4" data-id="element-6392">
          <button onClick={() => window.history.back()} className="w-full py-3 bg-primary text-background rounded-xl font-medium hover:bg-primaryHover transition-colors flex items-center justify-center gap-2" data-id="element-6393">
            <ArrowLeft className="w-4 h-4" data-id="element-6394" /> Go Back
          </button>
          <Link to="/app" className="w-full py-3 bg-surface border border-border rounded-xl font-medium hover:bg-surfaceHover transition-colors block" data-id="element-6395">
            Return to Dashboard
          </Link>
        </div>
      </motion.div>
    </div>;
}